"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawablePropertiesComponent = void 0;
var tslib_1 = require("tslib");
var core_shared_1 = require("@ikegps/core-shared");
var distance_input_1 = require("../../components/input/distance.input");
var distance_input_state_1 = require("../../components/input/distance.input.state");
var input_1 = require("../../components/input/input");
var input_state_1 = require("../../components/input/input.state");
var mithril_component_1 = require("../../components/mithril.component");
var modal_service_1 = require("../../components/modal/modal.service");
var modal_style_1 = require("../../components/modal/modal.style");
var theme_1 = require("../../components/theme");
var i18n_1 = require("../../i18n");
var mithril_1 = require("../../mithril");
var CSS = {
    content: 'c-DrawableProperties',
    title: 'c-DrawableProperties__Title'
};
(0, theme_1.addStyles)((_a = {},
    _a[CSS.content] = {
        'min-height': theme_1.DefaultTheme.space(20)
    },
    _a[CSS.title] = {
        'font-weight': 'bold',
        'padding-bottom': theme_1.DefaultTheme.space(4)
    },
    _a));
var DrawablePropertiesComponent = /** @class */ (function (_super) {
    tslib_1.__extends(DrawablePropertiesComponent, _super);
    function DrawablePropertiesComponent(drawable) {
        var _this = _super.call(this) || this;
        _this.isBase = false;
        if (core_shared_1.CollectionModelDrawableMarker.isBase(drawable)) {
            _this.offsetState = new distance_input_state_1.DistanceInputState(i18n_1.T.DRAWABLE_BASE_OFFSET);
            _this.offsetState.setValue(drawable.offset || 0);
            _this.offsetState.isAutoFocused = true;
            _this.isBase = true;
            _this.state = _this.offsetState;
        }
        else if (core_shared_1.CollectionModelDrawableLine.isLine(drawable) || core_shared_1.CollectionModelDrawableMarker.isMarker(drawable)) {
            _this.state = new input_state_1.InputState(i18n_1.T.DRAWABLE_TITLE);
            _this.state.setValue(drawable.label.text[0] || '');
            _this.state.isAutoFocused = true;
            _this.state.isLabelShown = false;
            _this.state.name = 'marker-label';
        }
        return _this;
    }
    Object.defineProperty(DrawablePropertiesComponent.prototype, "isValid", {
        get: function () {
            return this.state != null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DrawablePropertiesComponent.prototype, "nodes", {
        get: function () {
            var content = null;
            if (this.isBase) {
                content = distance_input_1.DistanceInput.view(this.offsetState);
            }
            else {
                content = input_1.Input.view(this.state);
            }
            return (0, mithril_1.m)('div', { className: CSS.content }, [
                (0, mithril_1.m)('div', { className: CSS.title }, (0, i18n_1.Translate)(this.state.label)),
                content
            ]);
        },
        enumerable: false,
        configurable: true
    });
    DrawablePropertiesComponent.prototype.viewActions = function () {
        var disabled = this.state.hasError();
        return (0, mithril_1.m)('div', { className: modal_style_1.CSS.actions }, [
            (0, mithril_1.m)('button', { className: 'mdl-button ' + modal_style_1.CSS.action.cancel, type: 'button', onclick: function () { return modal_service_1.ModalService.close(false); } }, (0, i18n_1.Translate)(i18n_1.T.CANCEL)),
            (0, mithril_1.m)('button', { className: 'mdl-button mdl-button--accent ' + modal_style_1.CSS.action.ok, disabled: disabled, type: 'submit' }, (0, i18n_1.Translate)(i18n_1.T.OK))
        ]);
    };
    DrawablePropertiesComponent.prototype.open = function () {
        var _this = this;
        return modal_service_1.ModalService.open({
            title: i18n_1.T.SETTINGS_TITLE,
            onSubmit: function () { return modal_service_1.ModalService.close(true); },
            content: function () { return _this.nodes; },
            actions: function () { return _this.viewActions(); }
        });
    };
    return DrawablePropertiesComponent;
}(mithril_component_1.IMithrilStateComponent));
exports.DrawablePropertiesComponent = DrawablePropertiesComponent;
//# sourceMappingURL=drawable.properties.js.map